var _Circle, _Path, _Path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Circle, Path } from "react-native-svg";
function SvgCircleDollar(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Circle || (_Circle = /*#__PURE__*/React.createElement(Circle, {
    cx: 10,
    cy: 10,
    r: 7.5,
    stroke: "#40AFED",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M12.333 7.5a1.667 1.667 0 00-1.5-.833H9.167a1.667 1.667 0 100 3.333h1.666a1.667 1.667 0 110 3.333H9.167c-.616.021-1.193-.3-1.5-.833",
    stroke: "#40AFED",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    d: "M10.8 5a.8.8 0 00-1.6 0h1.6zM9.2 6.667a.8.8 0 001.6 0H9.2zm1.6 6.666a.8.8 0 00-1.6 0h1.6zM9.2 15a.8.8 0 001.6 0H9.2zm0-10v1.667h1.6V5H9.2zm0 8.333V15h1.6v-1.667H9.2z",
    fill: "#40AFED"
  })));
}
export default SvgCircleDollar;